import { render, staticRenderFns } from "./check-info.vue?vue&type=template&id=f8c6f5ea&scoped=true"
import script from "./check-info.vue?vue&type=script&lang=js"
export * from "./check-info.vue?vue&type=script&lang=js"
import style0 from "./check-info.vue?vue&type=style&index=0&id=f8c6f5ea&prod&lang=scss&scoped=true"
import style1 from "./check-info.vue?vue&type=style&index=1&id=f8c6f5ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c6f5ea",
  null
  
)

export default component.exports